import styled, { css } from 'styled-components';
import { Dialog } from '@mui/material';
import { QuestionContainer } from '../FeedbacksComponents/FeedbackTeacherLaptop/style';

export const StepCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 20px;
  background-color: var(--white, #ffffff);
  border-radius: 16px;
  border-bottom: 1px solid var(--color-neutral-alpha-90, #c9c6cc80);
`;

export const StepHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StepNumberBadge = styled.div`
  width: fit-content;
  padding: 0 12px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid #dec7ff;
  color: #7200e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const StepTitle = styled.h3`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 20px;
  font-weight: 600;
  color: var(--text, #1e252a);
  margin: 0;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  width: 520px !important;
  min-width: 520px;
  max-width: 520px;
  max-height: 90vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 40px 40px;
  z-index: 1001;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  padding: 4px;

  &:hover {
    color: #374151;
  }
`;

export const ModalTitle = styled.h2`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  text-align: center;
  margin: 0 0 12px;
`;

export const ModalSubtitle = styled.p`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  margin: 0 0 24px;
  line-height: 1.5;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  background-color: #7200e0;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #5b00b5;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(114, 0, 224, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #c9c6cc;
  }
`;

export const FooterNote = styled.p`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
  margin: 12px 0 0;
`;

export const DropZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 24px;
  gap: 8px;
  background: var(--color-neutral-white, #f1e6fc);
  border: 1px dashed #c4b5fd;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover,
  &[data-active='true'] {
    background: #ede9fe;
    border-color: #7200e0;
  }
`;

export const DropZoneText = styled.p`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #7200e0;
  margin: 0;
  text-align: center;
`;

export const DropZoneHint = styled.p`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  color: #918b97;
  margin: 0;
  text-align: center;
  max-width: 320px;
  line-height: 1.4;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const QuestionTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 14px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: var(--text, #1e252a);
  resize: vertical;
  box-sizing: border-box;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #7200e0;
    box-shadow: 0 0 0 2px rgba(114, 0, 224, 0.1);
  }
`;

export const AddQuestionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #7200e0;
  color: #ffffff;
  border: none;
  border-radius: 32px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;

  &:hover:not(:disabled) {
    background: #5b00b5;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EntryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #7200e0;
  color: #ffffff;
  border: none;
  border-radius: 32px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #5b00b5;
  }
`;

export const SectionTitle = styled.h2`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 20px;
  font-weight: 600;
  color: var(--text, #1e252a);
  margin: 0 0 16px;
`;

export const FileNameChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #ede9fe;
  border-radius: 16px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  color: #7200e0;
`;

export const FileList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const ReviewTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid rgba(201, 198, 204, 0.5);
  border-radius: 8px;
  overflow: hidden;
`;

export const ReviewTableHead = styled.thead`
  background: rgba(242, 241, 243, 0.5);
`;

export const ReviewTableHeaderCell = styled.th`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(201, 198, 204, 0.5);
`;

export const ReviewTableRow = styled.tr`
  transition: background 0.15s ease;

  &:hover {
    background: rgba(242, 241, 243, 0.5);
  }
`;

export const ReviewTableCell = styled.td`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  color: #4b464f;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(201, 198, 204, 0.5);
  vertical-align: middle;
`;

export const ReviewStatus = styled.span`
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 12px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 12px;
  font-weight: 500;
  background: ${({ $variant }) => ($variant === 'ready' ? '#dcfce7' : '#fef3c7')};
  color: ${({ $variant }) => ($variant === 'ready' ? '#166534' : '#92400e')};
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px;
  background: #fafafa;
  border-radius: 12px;
  border: 1px solid rgba(201, 198, 204, 0.5);
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const SummaryLabel = styled.span`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #6b7280;
`;

export const SummaryValue = styled.span`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`;

export const DashboardShell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  background: var(--white, #fff);
  border-radius: 16px;
  border: 1px solid rgba(201, 198, 204, 0.5);
`;

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const DashboardTitle = styled.h2`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 24px;
  font-weight: 600;
  color: var(--text, #1e252a);
`;

export const DashboardCard = styled.div`
  padding: 20px;
  background: #fafafa;
  border-radius: 12px;
`;

export const FlowPage = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;





export const SplitButtonWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const SplitButtonContainer = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 40px;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(114, 0, 224, 0.25);
`;

export const SplitButtonMain = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 8px 12px;
  border: none;
  background: var(--light-mode-purple, #7200e0);
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-weight: 500;
  font-size: var(--font-size-l, 16px);
  line-height: 24px;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  pointer-events: auto;
`;

export const SplitButtonDropdown = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 100%;
  padding: 0;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  background: #5500b0;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #43008c;
  }
`;

export const SplitButtonChevron = styled.img`
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
`;

export const NewDraftMenu = styled.div`
  position: fixed;
  z-index: 10001;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(123, 115, 130, 0.25);
  overflow: hidden;
`;

export const NewDraftMenuItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: none;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(242, 241, 243, 0.8);
  }
`;

export const NewDraftMenuIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: ${({ $purple }) => ($purple ? 'none' : 'none')};
`;

export const NewDraftMenuLabel = styled.span`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #4b464f;
`;














export const DraftsMainTitle = styled.h2`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 24px;
  font-weight: 600;
  color: #1e252a;
`;

export const DraftsMainSubtitle = styled.p`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  max-width: 480px;
`;













// What the flow needs wherever it is mounted: a column its single child fills.
const bulkUploadFlowColumn = css`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${({ $transparent }) => ($transparent ? 'transparent' : '#fff')};
  box-sizing: border-box;
  padding: 0;

  > * {
    flex: 1;
    min-height: 0;
    width: 100%;
  }
`;

export const BulkUploadFullPageRoot = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  // Clears the main nav rail.
  left: 80px;
  z-index: 100002;
  ${bulkUploadFlowColumn}
`;

// Inside BulkUploadDialog the paper already owns the frame and the stacking, so
// the flow only has to fill it. Positioning it fixed here would break out of the
// popup the whole flow is supposed to live in.
export const BulkUploadDialogRoot = styled.div`
  height: 100%;
  min-height: 0;
  ${bulkUploadFlowColumn}
`;

/**
 * /drafts/:assignmentId stacks in normal flow rather than as a fixed overlay, so the top
 * bar and settings strip above the wizard keep whatever height they actually take — the
 * strip wraps under 1024px, so any hardcoded top offset would be wrong there.
 */
export const DraftWizardPageRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`;

export const DraftWizardBody = styled.div`
  flex: 1;
  min-height: 0;
  margin-left: ${({ $left }) => $left}px;
  display: flex;
  flex-direction: column;
  background: #faf7fc;
  box-sizing: border-box;
  transition: margin-left 0.3s ease-in;

  > *:last-child {
    flex: 1;
    min-height: 0;
  }
`;

export const BulkUploadWizard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0;
  border: none;
  overflow: hidden;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const BulkUploadWizardHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  height: 62px;
  box-sizing: border-box;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(201, 198, 204, 0.5);
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  @media (max-width: 1200px) {
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    height: auto;
    min-height: 62px;
    padding: 12px 16px;
    gap: 12px;
  }
`;
export const BulkUploadWizardTitle = styled.h1`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #1e252a;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    font-size: 18px;
    line-height: 26px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const BulkUploadWizardHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
`;

export const BulkUploadWizardClose = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  line-height: 0;
  flex-shrink: 0;
  border-radius: 0;

  img {
    display: block;
  }
`;

export const BulkUploadStepper = styled.ol`
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-shrink: 1;
  min-width: 0;
  justify-content: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1200px) {
    gap: 4px;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    order: -1;
    gap: 4px;
  }
`;

export const BulkUploadStepperItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${props => props.$clickable ? 'pointer' : 'default'};
  transition: opacity 0.2s ease;

  @media (max-width: 1200px) {
    gap: 6px;
  }

  @media (max-width: 768px) {
    gap: 4px;
  }

  ${props => props.$clickable && `
    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.6;
    }
  `}
`;

export const BulkUploadStepperCircle = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  flex-shrink: 0;
  background: ${({ $status }) => ($status === 'current' ? '#7200e0' : '#fff')};
  color: ${({ $status }) =>
    $status === 'current' ? '#fff' : $status === 'complete' ? '#7200e0' : '#918b97'};
  border: 1.5px solid
    ${({ $status }) => ($status === 'upcoming' ? '#c9c6cc' : '#7200e0')};
  transition: all 0.2s ease;
`;

export const BulkUploadStepperLabel = styled.span`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: ${({ $status }) => ($status === 'current' ? 600 : 500)};
  line-height: 24px;
  color: ${({ $status }) =>
    $status === 'current' || $status === 'complete' ? '#7200e0' : '#918b97'};
  white-space: nowrap;

  @media (max-width: 1200px) {
    font-size: 13px;
  }

  @media (max-width: 900px) {
    font-size: 12px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BulkUploadStepperDivider = styled.span`
  width: 24px;
  height: 1px;
  background: #c9c6cc;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    width: 16px;
  }

  @media (max-width: 900px) {
    width: 8px;
  }

  @media (max-width: 768px) {
    width: 6px;
  }
`;

export const BulkUploadWizardBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    overflow-y: auto;
  }
`;

export const BulkUploadResponsesPanel = styled.div`
  flex: 1;
  min-width: 0;
  padding: 24px 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  border-right: 1px solid rgba(201, 198, 204, 0.5);

  @media (max-width: 768px) {
    padding: 16px;
    border-right: none;
    border-bottom: 1px solid rgba(201, 198, 204, 0.5);
  }
`;

export const BulkUploadPagesPanel = styled.aside`
  width: 523px;
  flex-shrink: 0;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  border-left: 1px solid rgba(201, 198, 204, 0.3);

  @media (max-width: 1200px) {
    width: 380px;
    padding: 20px 16px;
  }

  @media (max-width: 900px) {
    width: 320px;
    padding: 16px 12px;
  }

  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(201, 198, 204, 0.3);
    padding: 16px;
  }
`;

export const BulkUploadPagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 141px);
  gap: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  max-height: 650px;
  padding: 4px 8px 4px 4px;
  justify-content: start;
  scrollbar-width: thin;
  scrollbar-color: #7200e0 transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #7200e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #5b00b5;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 141px);
    gap: 16px;
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 12px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    justify-content: stretch;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const BulkUploadSectionTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: ${({ $plain }) => ($plain ? '#1e252a' : '#7200e0')};
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const BulkUploadInstructionList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: instruction-counter;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulkUploadInstructionItem = styled.li`
  margin: 0;
  padding-left: 28px;
  position: relative;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  line-height: 20px;
  color: #4b464f;
  counter-increment: instruction-counter;

  &::before {
    content: counter(instruction-counter) ".";
    position: absolute;
    left: 0;
    font-weight: 600;
    color: #7200e0;
  }
`;

export const BulkUploadTabRow = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const BulkUploadTab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  box-sizing: border-box;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1.5px solid ${({ $active }) => ($active ? '#7200e0' : '#c9c6cc')};
  background: ${({ $active }) => ($active ? 'rgba(241, 230, 252, 0.35)' : '#fff')};
  color: ${({ $active }) => ($active ? '#7200e0' : '#7b7382')};
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: #7200e0;
    color: #7200e0;
    background: rgba(241, 230, 252, 0.35);
  }

  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: currentColor;
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
  }
`;
export const BulkUploadHelperText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #6b7280;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const BulkUploadDropArea = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1.5px dashed #c9c6cc;
  border-radius: 12px;
  padding: ${({ $hasFiles }) => ($hasFiles ? '20px 16px' : '48px 20px')};
  display: flex;
  flex-direction: column;
  align-items: ${({ $hasFiles }) => ($hasFiles ? 'stretch' : 'center')};
  justify-content: ${({ $hasFiles }) => ($hasFiles ? 'flex-start' : 'center')};
  gap: ${({ $hasFiles }) => ($hasFiles ? '16px' : '12px')};
  background: #fff;
  transition: border-color 0.2s, background 0.2s;
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  &[data-active='true'] {
    border-color: #7200e0;
    background: rgba(241, 230, 252, 0.35);
  }
`;

export const BulkUploadAddFilesButton = styled.button`
  height: 56px;
  box-sizing: border-box;
  padding: 16px 20px;
  border-radius: 999px;
  border: ${({ $outline }) => ($outline ? '1.5px solid #7200e0' : 'none')};
  background: ${({ $outline }) => ($outline ? '#ffffff' : '#7200e0')};
  color: ${({ $outline }) => ($outline ? '#7200e0' : '#fff')};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);

  &:hover:not(:disabled) {
    background: ${({ $outline }) =>
      $outline ? 'rgba(241, 230, 252, 0.45)' : '#5b00b5'};
  }

  &:disabled {
    background: #c9c6cc;
    border-color: #c9c6cc;
    color: #fff;
    cursor: not-allowed;
  }
`;

export const BulkUploadDropHint = styled.span`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  line-height: 1.45;

  &[data-size='sm'] {
    font-size: 13px;
    color: #918b97;
    line-height: 1.35;
    max-width: 270px;
  }
`;

export const BulkUploadAddMoreZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const BulkUploadFilesSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
`;

export const BulkUploadFilesHeading = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e252a;
  padding-bottom: 4px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const BulkUploadFileList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BulkUploadFileRow = styled.li`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 48px;
  padding: 12px;
  border: 1px solid ${({ $selected }) => ($selected ? '#7200e0' : 'rgba(201, 198, 204, 0.8)')};
  border-radius: 8px;
  background: ${({ $selected }) =>
    $selected ? 'rgba(241, 230, 252, 0.45)' : '#fff'};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #7200e0;
    background: rgba(241, 230, 252, 0.35);
  }
`;

export const BulkUploadDragHandle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  color: #141414;
  cursor: grab;
  flex-shrink: 0;
`;

export const BulkUploadFileIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const BulkUploadFileMeta = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BulkUploadFileName = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #1e252a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;

export const BulkUploadFilePages = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #918b97;
  margin-top: 0;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const BulkUploadFileDelete = styled.button`
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 0;
  border-radius: 4px;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(248, 113, 113, 0.15);
  }
`;

export const BulkUploadPagesCount = styled.span`
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: #7200e0;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
`;

export const BulkUploadPagesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
`;

export const BulkUploadPagePreviewHoverOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(30, 37, 42, 0.55);
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 2;
  pointer-events: auto;
  cursor: pointer;

  img {
    width: 20px !important;
    height: 20px !important;
    object-fit: contain !important;
  }

  @media (hover: none) {
    opacity: 1;
  }
`;

export const BulkUploadPagePreviewIcon = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  outline: none;
  line-height: 0;
  position: absolute;
  left: ${({ $posX }) => $posX ?? 50}%;
  top: ${({ $posY }) => $posY ?? 50}%;
  transform: translate(-50%, -50%);

  &:focus-visible {
    outline: 2px solid #7200e0;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const BulkUploadPageCard = styled.div`
  border: 2px solid
    ${({ $highlighted, $isDragging, $isOverlay, $disabled }) =>
      $isDragging || $isOverlay || $highlighted ? '#7200e0' : $disabled ? '#ccc' : 'transparent'};
  border-radius: 8px;
  padding: 0;
  width: ${({ $organise }) => ($organise ? '177px' : 'auto')};
  height: auto;
  background: ${({ $highlighted, $disabled }) =>
    $disabled ? '#f5f5f5' : $highlighted ? 'rgba(226, 208, 255, 0.25)' : '#ffffff'};
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow: visible;
  box-shadow: ${({ $isDragging, $isOverlay, $highlighted, $disabled }) =>
    $isDragging || $isOverlay
      ? '0 8px 20px rgba(114, 0, 224, 0.25)'
      : $highlighted
        ? '0 4px 12px rgba(114, 0, 224, 0.2)'
        : $disabled
          ? '0 1px 2px rgba(0, 0, 0, 0.2)'
          : '0 2px 4px rgba(0, 0, 0, 0.46)'};
  opacity: ${({ $isDragging, $isOverlay, $disabled }) =>
    $isDragging && !$isOverlay ? 0 : $disabled ? 0.6 : 1};
  touch-action: none;
  will-change: ${({ $isDragging, $isOverlay }) =>
    $isDragging || $isOverlay ? 'transform' : 'auto'};
  pointer-events: ${({ $isOverlay, $disabled }) =>
    $isOverlay ? 'none' : $disabled ? 'none' : 'auto'};

  ${BulkUploadDragHandle} {
    align-self: stretch;
    justify-content: center;
    width: 100%;
    height: ${({ $organise }) => ($organise ? '24px' : '18px')};
    padding: 0;
    background: rgba(241, 230, 252, 0.65);
    color: #141414;
    border-radius: 0;
    flex-shrink: 0;
  }

  &:hover ${BulkUploadPagePreviewHoverOverlay} {
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BulkUploadPagePreview = styled.div`
  position: relative;
  overflow: hidden;
  background: #ffffff;
  width: ${({ $organise }) => ($organise ? '161px' : '125px')};
  height: ${({ $organise }) => ($organise ? '228px' : '173px')};
  margin: ${({ $organise }) => ($organise ? '0 8px' : '0 8px 8px 8px')};
  border-radius: 0;
  box-shadow: none;
  border: 1px solid rgba(201, 198, 204, 0.5);
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    aspect-ratio: ${({ $organise }) => ($organise ? '161 / 228' : '125 / 173')};
  }
`;

export const BulkUploadPageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #ffffff;
  display: block;
`;

export const BulkUploadManualPagePreview = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px;
  background: #ffffff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 7px;
  line-height: 1.35;
  color: #181718;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  box-sizing: border-box;
`;

export const BulkUploadPageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 8px;
  pointer-events: none;
  z-index: 3;

  > * {
    pointer-events: auto;
  }
`;

export const BulkUploadPageNumberOverlay = styled.span`
  background: #ffffff;
  border: 1px solid var(--color-neutral-90, #c9c6cc);
  border-left: none;
  border-bottom: none;
  border-radius: 0 4px 0 0;
  padding: 1px 8px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  line-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const BulkUploadPageDeleteOverlay = styled.button`
  border: 1px solid var(--color-neutral-90, #c9c6cc);
  background: #ffffff;
  border-radius: 4px;
  padding: 8px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.35);

  &:hover {
    background: #fee2e2;
    border-color: #f87171;
    transform: scale(1.05);
  }

  img {
    width: 24px;
    height: 24px;
  }
`;

export const BulkUploadSelectButton = styled.button`
  width: 161px;
  height: 40px;
  padding: 0 16px;
  background: ${({ $deselect }) => ($deselect ? '#d97706' : '#7200e0')};
  color: #ffffff;
  border: none;
  border-radius: 999px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 8px;
  flex-shrink: 0;

  &:hover {
    background: ${({ $deselect }) => ($deselect ? '#b45309' : '#5b00b5')};
    transform: translateY(-1px);
    box-shadow: ${({ $deselect }) =>
      $deselect ? '0 4px 8px rgba(217, 119, 6, 0.3)' : '0 4px 8px rgba(114, 0, 224, 0.3)'};
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const BulkUploadPageFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 12px;
  background: transparent;
  height: 44px;
`;

export const BulkUploadPageNumber = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #1e252a;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  line-height: 1;
`;

export const BulkUploadPageDelete = styled.button`
  border: 1.5px solid #f3b4b4;
  background: #fff;
  border-radius: 8px;
  padding: 7px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  line-height: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover {
    background: #fee2e2;
    border-color: #f87171;
    transform: scale(1.05);
    box-shadow: 0 2px 4px rgba(248, 113, 113, 0.2);
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const BulkUploadWizardFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 62px;
  box-sizing: border-box;
  padding: 11px 20px;
  border-top: 1px solid rgba(201, 198, 204, 0.5);
  background: #fff;
  flex-shrink: 0;
  margin-top: auto;
  z-index: 5;
  width: 100%;
  max-width: 100%;

  @media (max-width: 480px) {
    flex-direction: column;
    height: auto;
    padding: 12px 16px;
    gap: 12px;
    align-items: stretch;
  }
`;

export const BulkUploadBackButton = styled.button`
  border: none;
  background: transparent;
  color: #7200e0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  padding: 8px 0;
  border-radius: 6px;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: rgba(241, 230, 252, 0.45);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
    text-align: center;
  }
`;

export const BulkUploadContinueButton = styled.button`
  margin-left: auto;
  min-width: 90px;
  height: 40px;
  box-sizing: border-box;
  padding: 8px 20px;
  border: none;
  border-radius: 999px;
  background: #7200e0;
  color: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  img {
    width: 20px;
    height: 20px;
    display: block;
    flex-shrink: 0;
  }

  &:disabled {
    background: #c9c6cc;
    color: #fff;
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:hover:not(:disabled) {
    background: #5b00b5;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(114, 0, 224, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    margin-left: 0;
    width: 100%;
    order: -1;
  }
`;
export const BulkUploadManualTextArea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 14px;
  border: 1px solid #c9c6cc;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #918b97;
  }

  &:focus {
    outline: none;
    border-color: #7200e0;
    box-shadow: 0 0 0 2px rgba(114, 0, 224, 0.1);
  }
`;

export const BulkUploadManualForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BulkUploadManualLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: #4b464f;
`;

export const BulkUploadManualInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #c9c6cc;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  transition: border-color 0.2s ease;

  &::placeholder {
    color: #918b97;
  }

  &:focus {
    outline: none;
    border-color: #7200e0;
    box-shadow: 0 0 0 2px rgba(114, 0, 224, 0.1);
  }
`;

export const BulkUploadAddToPagesButton = styled.button`
  align-self: stretch;
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  padding: 16px 20px;
  border: none;
  border-radius: 999px;
  background: #7200e0;
  color: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    background: #c9c6cc;
    color: #fff;
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:hover:not(:disabled) {
    background: #5b00b5;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(114, 0, 224, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const BulkUploadPagesScrollAnchor = styled.div`
  grid-column: 1 / -1;
  height: 1px;
`;

export const AddQuestionPanel = styled.div`
  flex: 1;
  min-width: 0;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: ${({ $fillHeight }) => ($fillHeight ? '380px' : 'auto')};
`;

export const AddQuestionFieldLabel = styled.label`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: #1e252a;
`;

export const AddQuestionInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #1e252a;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #7200e0;
    box-shadow: 0 0 0 2px rgba(114, 0, 224, 0.1);
  }
`;

export const AddQuestionTextarea = styled(QuestionTextarea)`
  min-height: 160px;
`;

export const AddStimulusButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 8px 16px;
  border-radius: 999px;
  border: none;
  background: #7200e0;
  color: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #5b00b5;
  }
`;

export const AddStimulusIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
  filter: brightness(0) invert(1);
`;
export const RemoveStimulusButton = styled.button`
  width: fit-content;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  background: #b91c1c;
  color: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #991b1b;
  }
`;

export const AddQuestionMascot = styled.img`
  width: 143px;
  height: 169px;
  object-fit: contain;
  align-self: flex-end;
  margin-top: auto;
`;

export const BulkUploadStudentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #7200e0 transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #7200e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #5b00b5;
  }
`;

export const BulkUploadStudentCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(201, 198, 204, 0.45);
  background: ${({ $active }) => ($active ? 'rgba(241, 230, 252, 0.55)' : '#fff')};
  text-align: left;
  box-shadow: none;
  transition: all 0.2s ease;
  box-sizing: border-box;

  ${({ $isDropTarget }) => $isDropTarget && `
    background: rgba(114, 0, 224, 0.08);
    border-color: #7200e0;
    border-width: 2px;
    box-shadow: 0 0 0 2px rgba(114, 0, 224, 0.15);
  `}
`;

export const BulkUploadStudentCardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const BulkUploadStudentThumbs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 2px 0 0 34px;
`;

export const BulkUploadStudentThumbHoverOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(30, 37, 42, 0.55);
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 1;
  pointer-events: none;

  img {
    width: 12px !important;
    height: 12px !important;
    object-fit: contain !important;
  }
`;

export const BulkUploadStudentThumbHandle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 14px;
  color: #141414;
  line-height: 0;
  cursor: grab;
  touch-action: none;
  background: rgba(241, 230, 252, 0.9);
  flex-shrink: 0;
  border-radius: 5px 5px 0 0;

  &:active {
    cursor: grabbing;
  }
`;

export const BulkUploadStudentThumbBody = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  background: #fff;
  border-radius: ${({ $review }) => ($review ? '5px' : '0 0 5px 5px')};

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }
`;

export const BulkUploadStudentThumb = styled.div`
  position: relative;
  width: 64px;
  height: 84px;
  border-radius: 6px;
  overflow: ${({ $review }) => ($review ? 'hidden' : 'visible')};
  border: 1px solid #c9c6cc;
  background: #fff;
  flex-shrink: 0;
  cursor: pointer;
  touch-action: none;
  display: flex;
  flex-direction: column;
  opacity: ${({ $isDragging, $isOverlay }) => ($isDragging && !$isOverlay ? 0 : 1)};
  box-shadow: ${({ $isOverlay }) =>
    $isOverlay ? '0 8px 20px rgba(114, 0, 224, 0.25)' : 'none'};
  z-index: ${({ $isOverlay }) => ($isOverlay ? 20 : 1)};

  &:hover ${BulkUploadStudentThumbHoverOverlay} {
    opacity: 1;
  }
`;

export const BulkUploadStudentThumbRemove = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  line-height: 0;

  img {
    display: block;
    width: 14px;
    height: 14px;
  }
`;

export const BulkUploadStudentThumbNumber = styled.span`
  position: absolute;
  right: 3px;
  bottom: 3px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 3px;
  background: rgba(30, 37, 42, 0.75);
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  text-align: center;
  z-index: 2;
`;

export const BulkUploadAllAssigned = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 16px;
  gap: 12px;
`;

export const BulkUploadAllAssignedArt = styled.img`
  width: auto;
  height: min(220px, 40vh);
  max-width: min(170px, 50%);
  object-fit: contain;
  display: block;
  margin-bottom: 8px;
`;

export const BulkUploadAllAssignedTitle = styled.h3`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 18px;
  font-weight: 600;
  color: #1e252a;
`;

export const BulkUploadAllAssignedText = styled.p`
  margin: 0;
  max-width: 320px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  color: #7b7382;
`;

export const BulkUploadAllAssignedArrow = styled.div`
  position: absolute;
  right: 0;
  top: 6%;
  bottom: 22%;
  width: min(180px, 40%);
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: right center;
    display: block;
  }
`;

export const BulkUploadAddStudentLink = styled.button`
  margin-left: auto;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #7200e0;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #5b00b5;
  }
`;

export const BulkUploadAddStudentDropdownWrapper = styled.div`
  position: relative;
  margin-left: auto;
`;

export const BulkUploadAddStudentDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 322px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  padding: 20px;
  z-index: 100;

  &::before {
    content: '';
    position: absolute;
    top: -6px;
    right: 20px;
    width: 12px;
    height: 12px;
    background: #ffffff;
    transform: rotate(45deg);
    box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.05);
  }
`;

export const BulkUploadAddStudentDropdownHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const BulkUploadAddStudentDropdownTitle = styled.h3`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 18px;
  font-weight: 600;
  color: #1e252a;
`;

export const BulkUploadAddStudentDropdownSubtitle = styled.p`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
`;

export const BulkUploadStudentAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $hue }) =>
    `conic-gradient(from 30deg, hsl(${$hue}, 72%, 58%), hsl(${$hue + 72}, 68%, 52%), hsl(${$hue + 144}, 70%, 60%))`};
`;

export const BulkUploadStudentInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BulkUploadStudentName = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #1e252a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BulkUploadStudentPages = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 12px;
  line-height: 16px;
  color: #4b464f;
  margin-top: 4px;

  strong {
    font-weight: 600;
    color: #1e252a;
  }
`;

export const BulkUploadOrganiseLayout = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

export const BulkUploadOrganiseStudents = styled.aside`
  width: 260px;
  flex-shrink: 0;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-right: 1px solid rgba(201, 198, 204, 0.5);
  background: #fff;
  min-height: 0;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid rgba(201, 198, 204, 0.5);
    padding: 16px;
  }
`;

export const BulkUploadOrganisePagesMain = styled.div`
  flex: 1;
  min-width: 0;
  padding: 24px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fff;
  min-height: 0;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const BulkUploadStudentDropZone = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  min-height: ${({ $hasPages }) => ($hasPages ? 'auto' : '72px')};
  padding: 12px;
  border-radius: 10px;
  border: 1.5px dashed ${({ $active, $hasPages }) =>
    $active ? '#7200e0' : $hasPages ? 'rgba(114, 0, 224, 0.35)' : '#93c5fd'};
  background: ${({ $active, $hasPages }) =>
    $active
      ? 'rgba(241, 230, 252, 0.45)'
      : $hasPages
        ? 'rgba(241, 230, 252, 0.2)'
        : 'rgba(239, 246, 255, 0.5)'};
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    border-color: #7200e0;
    background: ${({ $active, $hasPages }) =>
      $active
        ? 'rgba(241, 230, 252, 0.55)'
        : $hasPages
          ? 'rgba(241, 230, 252, 0.3)'
          : 'rgba(241, 230, 252, 0.15)'};
  }
`;

export const BulkUploadStudentDropMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const BulkUploadStudentDropClear = styled.button`
  border: none;
  background: transparent;
  padding: 2px;
  margin-left: auto;
  cursor: pointer;
  line-height: 0;
  display: inline-flex;
`;

export const BulkUploadPageTitle = styled.div`
  padding: 8px 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #1e252a;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  height: 24px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
`;

export const BulkUploadOrganisePagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 177px);
  gap: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  padding: 4px 8px 12px 4px;
  align-content: start;
  justify-content: start;
  scrollbar-width: thin;
  scrollbar-color: #7200e0 transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #7200e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #5b00b5;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    justify-content: stretch;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const BulkUploadAssignSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1.5px solid rgba(114, 0, 224, 0.3);
  border-radius: 12px;
  background: rgba(241, 230, 252, 0.15);
`;

export const BulkUploadAssignButton = styled.button`
  width: 100%;
  padding: 10px 20px;
  background: #7200e0;
  color: #ffffff;
  border: none;
  border-radius: 999px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #5b00b5;
  }

  &:disabled {
    background: #7B7382;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const BulkUploadReviewLayout = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

export const BulkUploadReviewMain = styled.div`
  flex: 1;
  min-width: 0;
  padding: 24px 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-right: 1px solid rgba(201, 198, 204, 0.5);

  @media (max-width: 768px) {
    padding: 16px;
    border-right: none;
    border-bottom: 1px solid rgba(201, 198, 204, 0.5);
  }
`;

export const BulkUploadReviewNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const BulkUploadReviewNavButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 1.5px solid ${({ disabled }) => (disabled ? '#e5e2e8' : '#7200e0')};
  border-radius: 999px;
  background: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: ${({ disabled }) => (disabled ? '#c9c6cc' : '#7200e0')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: rgba(241, 230, 252, 0.35);
  }

  img {
    opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
    filter: ${({ disabled }) =>
      disabled
        ? 'none'
        : 'brightness(0) saturate(100%) invert(16%) sepia(90%) saturate(4500%) hue-rotate(270deg) brightness(85%)'};
    transition: opacity 0.2s ease;
  }
`;

export const BulkUploadReviewNavCenter = styled.div`
  flex: 1;
  text-align: center;
  min-width: 0;
`;

export const BulkUploadReviewStudentName = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: #1e252a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BulkUploadReviewStudentMeta = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  color: #918b97;
  margin-top: 2px;
`;

export const BulkUploadReviewViewer = styled.div`
  flex: 1;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(201, 198, 204, 0.6);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
`;

export const BulkUploadReviewViewerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 16px;
  background: rgba(241, 230, 252, 0.55);
  border-bottom: 1px solid rgba(201, 198, 204, 0.4);
`;

export const BulkUploadReviewViewOriginal = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 13px;
  font-weight: 500;
  color: #7200e0;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: rgba(241, 230, 252, 0.45);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const BulkUploadReviewToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 12px;
  border-bottom: 1px solid rgba(201, 198, 204, 0.4);
  background: #fafafa;
`;

export const BulkUploadReviewToolbarButton = styled.button`
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #4b464f;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(114, 0, 224, 0.08);
    color: #7200e0;
  }

  &:active {
    background: rgba(114, 0, 224, 0.15);
  }

  &[data-style='italic'] {
    font-style: italic;
  }

  &[data-style='underline'] {
    text-decoration: underline;
  }

  &[data-style='line-through'] {
    text-decoration: line-through;
  }
`;

export const BulkUploadReviewContent = styled.div`
  flex: 1;
  padding: 20px 24px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  line-height: 1.65;
  color: #1e252a;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  outline: none;
  scrollbar-width: thin;
  scrollbar-color: #7200e0 transparent;

  [data-line] {
    display: block;
    background: rgba(125, 211, 252, 0.35);
    color: inherit;
    margin-bottom: 1px;
    padding: 0 2px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #7200e0;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #5b00b5;
  }
`;

export const BulkUploadReviewEmptyState = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-size: 14px;
  color: #918b97;
`;

export const BulkUploadReviewPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px;
  border-top: 1px solid rgba(201, 198, 204, 0.4);
`;

export const BulkUploadReviewPageDot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: ${({ $active }) => ($active ? '#7200e0' : '#d1d5db')};
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $active }) => ($active ? '#5b00b5' : '#918b97')};
    transform: scale(1.2);
  }
`;

export const BulkUploadStudentListPanel = styled.aside`
  width: 415px;
  flex-shrink: 0;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: #fff;
  min-height: 0;
  border-left: 1px solid rgba(201, 198, 204, 0.5);

  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(201, 198, 204, 0.5);
    padding: 16px;
  }
`;

export const BulkUploadStudentListHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  img {
    margin-left: 6px;
  }
`;

export const BulkUploadStudentListTitle = styled.h3`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  color: #1e252a;
`;

export const BulkUploadStudentCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const BulkUploadStudentCardIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #918b97;
`;

export const BulkUploadMoreDots = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 16px;
  height: 16px;

  &::before,
  &::after {
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #141414;
  }
`;

// Draft Submissions View Styles
export const DraftsMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export const DraftsMainHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StudentDropdownWrapper = styled.div`
  width: 100%;
  max-width: 400px;
`;

export const SubmissionNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid #e5e7eb;
  margin-top: 24px;

  span {
    font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
    font-size: 14px;
    color: #6b7280;
  }
`;

export const SubmissionNavigationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #9ca3af;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SubmissionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  color: #6b7280;

  span {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const ResponseSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h3 {
    margin: 0;
    font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
    font-size: 16px;
    font-weight: 600;
    color: #1e252a;
  }
`;

export const ResponseText = styled.div`
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

// ── /drafts/:assignmentId landing ─────────────────────────────────────────────
// The route wears the feedback page's chrome, so the screen inside it is built
// from the same parts /documents/:id uses: a settings strip, then a centred
// column of its question cards on the same wash. The second card is where that
// page puts the response editor — a bulk draft has no single response, so it
// holds the button into the wizard instead.
//
// Sizing comes from DraftWizardBody's `> *:last-child`, which already makes this
// the panel that fills what the strip leaves.

export const DraftOverviewBody = styled.div`
  overflow-y: auto;
  background: #faf7fc;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px 24px 56px;

  @media (max-width: 768px) {
    padding: 20px 16px 40px;
  }
`;

export const DraftCard = styled(QuestionContainer).attrs({ as: 'section' })`
  max-width: 900px;
`;

export const DraftCardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $centered }) => ($centered ? 'center' : 'stretch')};
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
  gap: 16px;
  padding: ${({ $centered }) => ($centered ? '56px 40px' : '24px 40px 28px')};
  min-height: ${({ $centered }) => ($centered ? '220px' : 'auto')};
  text-align: ${({ $centered }) => ($centered ? 'center' : 'left')};

  @media (max-width: 768px) {
    padding: ${({ $centered }) => ($centered ? '40px 20px' : '20px')};
  }
`;

// Not QuestionText: that one is driven by the question slider's `slide` prop and
// has no muted state, and "no question added yet" is placeholder, not content.
export const DraftOverviewQuestion = styled.p`
  margin: 0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ $muted }) => ($muted ? '#9ca3af' : '#181718')};
  font-style: ${({ $muted }) => ($muted ? 'italic' : 'normal')};
  white-space: pre-wrap;
  word-wrap: break-word;
`;

// Large on purpose: it is the only thing on this page the teacher came here to
// press, and the wizard behind it is five steps of dense controls. The strip
// carries the same action as an ordinary header button.
export const DraftStartButton = styled.button`
  align-self: center;
  min-height: 48px;
  box-sizing: border-box;
  padding: 12px 28px;
  border: none;
  border-radius: 24px;
  background: #7200e0;
  color: #fff;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    background: #5b00b5;
    box-shadow: 0 4px 14px rgba(114, 0, 224, 0.3);
  }

  @media (max-width: 768px) {
    align-self: stretch;
  }
`;

export const DraftStartButtonIcon = styled.img`
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
`;

/** Keeps Submit Now layout intact inside QuestionTitleBox without forcing purple. */
export const DraftResponseSubmitWrap = styled.span`
  flex-shrink: 0;
  pointer-events: none;
  cursor: not-allowed;

  button {
    gap: 0 !important;
    align-items: stretch !important;
    min-height: 40px;
    height: 40px;
  }
`;

/**
 * The wizard as a popup over the draft, not as a page that replaces it.
 *
 * Entering the wizard used to swap the whole panel out, so the draft you were
 * working on — its question, its settings strip — disappeared behind the file
 * picker. Nearly full screen because the Organise step is a two-column drag
 * surface and anything dialog-sized makes it unusable.
 */
export const BulkUploadDialogPaper = styled(Dialog)`
  .MuiDialog-paper {
    width: 96vw;
    max-width: 1680px;
    height: 94vh;
    max-height: none;
    margin: 0;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #f2f1f3;

    /* The wizard fills the paper: WizardFrame is already a flex column when it
       is embedded, so it only needs to be told how tall it may grow. */
    > * {
      flex: 1;
      min-height: 0;
    }
  }
`;

/**
 * The way off the progress screen when a run was refused.
 *
 * Lives here rather than in FeedbackGenerationProgress because the screen is
 * shared and only the wizard knows where "back" goes.
 */
/**
 * Why a Review response is blank when extraction is the reason.
 *
 * The status is recorded on every page and used to be rendered nowhere, so a
 * student whose read failed was indistinguishable from one who wrote nothing.
 */
export const BulkUploadExtractionFailure = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: ${({ $notice }) => ($notice ? '0' : '4px')};
  padding: ${({ $notice }) => ($notice ? '8px 12px' : '4px 8px')};
  border-radius: 6px;
  border: 1px solid #f0c9c0;
  background: #fdf1ee;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 12px;
  line-height: 16px;
  color: #a03a1e;
`;

export const ProgressAction = styled.button`
  height: 40px;
  padding: 0 28px;
  border-radius: 999px;
  border: ${({ $primary }) =>
    $primary ? 'none' : '1px solid rgba(201, 198, 204, 0.85)'};
  background: ${({ $primary }) => ($primary ? '#7200e0' : '#fff')};
  color: ${({ $primary }) => ($primary ? '#fff' : '#302e32')};
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

/**
 * A file whose upload failed, listed beside the ones that landed.
 *
 * The drop no longer fails as a unit, so the failures need somewhere to live:
 * a row per file, carrying the reason and the way to try it again.
 */
export const BulkUploadFailedRow = styled.li`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 48px;
  padding: 12px;
  border: 1px solid rgba(220, 38, 38, 0.45);
  border-radius: 8px;
  background: rgba(254, 226, 226, 0.35);
`;

export const BulkUploadFailedReason = styled.div`
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #b91c1c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BulkUploadRetryButton = styled.button`
  flex-shrink: 0;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #7200e0;
  border-radius: 999px;
  background: #fff;
  color: #7200e0;
  font-family: var(--font-family-ibm_plex_sans, 'IBM Plex Sans', sans-serif);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: rgba(241, 230, 252, 0.6);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
